// mobileLayout.js -- Sprint Hub Phase 3B (T29)
// Mobile responsive CSS injection + useIsMobile hook
// ASCII only. No Unicode.
import { useState, useEffect } from 'react';

var MOBILE_CSS = `
@media (max-width: 768px) {
  .hub-sidebar-toggle { display: flex !important; }
  .hub-topbar { padding: 0 12px !important; }
  .hub-main { width: 100% !important; }
  .hub-modal { width: 95vw !important; margin: 0 auto; }
}
@media (max-width: 480px) {
  .hub-main > div:last-child { padding: 12px !important; }
}
`;

var injected = false;

export function injectMobileStyles() {
  if (injected) return;
  var style = document.createElement('style');
  style.setAttribute('data-hub-mobile', 'true');
  style.textContent = MOBILE_CSS;
  document.head.appendChild(style);
  injected = true;
}

export function useIsMobile(breakpoint) {
  var bp = breakpoint || 768;
  var _state = useState(window.innerWidth <= bp);
  var isMobile = _state[0]; var setIsMobile = _state[1];

  useEffect(function() {
    function onResize() {
      setIsMobile(window.innerWidth <= bp);
    }
    window.addEventListener('resize', onResize);
    return function() { window.removeEventListener('resize', onResize); };
  }, [bp]);

  return isMobile;
}
